<!-- @format -->

@if (_rule.type === "CourseUnitCountRule") {
  <sis-plan-structure-course-unit-count-rule
    [parentModule]="parentModule"
    [headingLevel]="headingLevel"
    [rule]="_rule"
    [planData]="planData"
    [planRuleData]="planRuleData"
    [planStateObject]="planStateObject"
    [planValidationResult]="planValidationResult"
    [validatablePlan]="validatablePlan"
    [groupPrefix]="groupPrefix"
    [selectionUIState]="selectionUIState"
    [ruleDepthLevel]="ruleDepthLevel" />
}
@if (_rule.type === "CreditsRule") {
  <sis-plan-structure-credits-rule
    [parentModule]="parentModule"
    [headingLevel]="headingLevel"
    [rule]="_rule"
    [planData]="planData"
    [planRuleData]="planRuleData"
    [planStateObject]="planStateObject"
    [planValidationResult]="planValidationResult"
    [validatablePlan]="validatablePlan"
    [groupPrefix]="groupPrefix"
    [selectionUIState]="selectionUIState"
    [ruleDepthLevel]="ruleDepthLevel" />
}
@if (_rule.type === "CompositeRule") {
  <sis-plan-structure-composite-rule
    [parentModule]="parentModule"
    [headingLevel]="headingLevel"
    [rule]="_rule"
    [planData]="planData"
    [planRuleData]="planRuleData"
    [planStateObject]="planStateObject"
    [planValidationResult]="planValidationResult"
    [validatablePlan]="validatablePlan"
    [groupPrefix]="groupPrefix"
    [selectionUIState]="selectionUIState"
    [ruleDepthLevel]="ruleDepthLevel" />
}
@if (_rule.type === "CourseUnitRule") {
  <sis-plan-structure-course-unit-rule
    [parentModule]="parentModule"
    [headingLevel]="headingLevel"
    [rule]="_rule"
    [planData]="planData"
    [planRuleData]="planRuleData"
    [planStateObject]="planStateObject"
    [planValidationResult]="planValidationResult"
    [validatablePlan]="validatablePlan"
    [ruleDepthLevel]="ruleDepthLevel"
    [selectionUIState]="selectionUIState" />
}
@if (_rule.type === "ModuleRule") {
  <sis-plan-structure-module-rule
    [parentModule]="parentModule"
    [headingLevel]="headingLevel"
    [rule]="_rule"
    [planData]="planData"
    [planRuleData]="planRuleData"
    [planStateObject]="planStateObject"
    [planValidationResult]="planValidationResult"
    [validatablePlan]="validatablePlan"
    [ruleDepthLevel]="ruleDepthLevel"
    [selectionUIState]="selectionUIState" />
}
@if (_rule.type === "AnyCourseUnitRule") {
  <sis-plan-structure-any-course-unit-rule
    [parentModule]="parentModule"
    [headingLevel]="headingLevel"
    [rule]="_rule"
    [planData]="planData"
    [planStateObject]="planStateObject"
    [planValidationResult]="planValidationResult"
    [validatablePlan]="validatablePlan"
    [ruleDepthLevel]="ruleDepthLevel"
    [selectionUIState]="selectionUIState"
    [currentUniversityOrgId]="currentUniversityOrgId"
    [crossStudyFeaturesEnabled]="crossStudyFeaturesEnabled"
    [cooperationNetworkIds]="cooperationNetworkIds"
    [curriculumPeriodIds]="curriculumPeriodIds" />
}
@if (_rule.type === "AnyModuleRule") {
  <sis-plan-structure-any-module-rule
    [parentModule]="parentModule"
    [headingLevel]="headingLevel"
    [rule]="_rule"
    [planData]="planData"
    [planStateObject]="planStateObject"
    [planValidationResult]="planValidationResult"
    [validatablePlan]="validatablePlan"
    [ruleDepthLevel]="ruleDepthLevel"
    [selectionUIState]="selectionUIState"
    [currentUniversityOrgId]="currentUniversityOrgId"
    [curriculumPeriodIds]="curriculumPeriodIds" />
}
